/**
 * Compatibility hook providing the same API as next/navigation's useSearchParams.
 * Next.js returns URLSearchParams directly, react-router returns [params, setParams].
 */
import { useSearchParams as useRRSearchParams } from "react-router-dom";

export function useSearchParams() {
  const [searchParams] = useRRSearchParams();
  return searchParams;
}
